import { withInstall, SFCWithInstall } from '@touchvue/utils';
import Checkbox from './src/Checkbox.vue';

export const ToCheckbox: SFCWithInstall<typeof Checkbox> = withInstall(Checkbox);
export * from './src/Checkbox.vue';
